import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";

const styles = (theme) => ({
	root: {
		position: "relative",
		zIndex: 102,
	},
	listWrapper: {
		transition: "max-height .3s ease",
		marginBottom: "50px",
	},
	list: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-start",
		position: "relative",
		marginRight: "-10px",
		marginLeft: "-10px",
		marginBottom: "-27px",
	},
	mobileButton: {
		display: "none",
	},
	noHiddenFilters: {
		marginBottom: "-60px",
	},
	oneHiddenFilter: {},
	twoHiddenFilters: {},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		noHiddenFilters: {
			marginBottom: "-60px",
		},
		oneHiddenFilter: {
			marginBottom: "-60px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		list: {
			marginRight: "-5px",
			marginLeft: "-5px",
		},
		listWrapper: {
			marginBottom: "40px",
		},
		oneHiddenFilter: {
			marginBottom: "-60px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			marginBottom: "20px",
		},
		list: {
			marginRight: "0",
			marginLeft: "0",
			marginBottom: 0,
		},
		listWrapper: {
			marginBottom: 0,
		},
		mobileButton: {
			display: "flex",
			justifyContent: "center",
			margin: "0 0 20px",
		},
	},
});

class FiltersLayout extends React.PureComponent {
	render() {
		let classes = this.props.classes;
		return (
			<div className={classes.root}>
				<Container>
					<div className={classes.wrapper}>
						{this.props.mobileButton && (
							<div className={classes.mobileButton}>{this.props.mobileButton}</div>
						)}
						<div
							className={classNames(classes.listWrapper, {
								[classes.noHiddenFilters]: this.props.noHiddenFilters,
								[classes.oneHiddenFilter]: this.props.oneHiddenFilter,
								[classes.twoHiddenFilters]: this.props.twoHiddenFilters,
							})}
						>
							<div className={classes.list}>{this.props.children}</div>
						</div>
					</div>
				</Container>
			</div>
		);
	}
}

export default withStyles(styles)(FiltersLayout);
